module.exports = __webpack_public_path__ + "static/kobold-trap-873026703bef197af2405ad63fa30c5a.png";